import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import toFullscreenSprite from 'assets/icons/fullscreen_to.svg';
import fromFullscreenSprite from 'assets/icons/fullscreen_from.svg';
import { FullScreenButtonStyled } from './styles/FullScreenButtonStyled';

class FullscreenButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      iconName: toFullscreenSprite.id,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      iconName: nextProps.isFullScreen ? fromFullscreenSprite.id : toFullscreenSprite.id,
    });
  }

  toggleFullscreen = (e) => {
    e.preventDefault();
    const { isFullScreen, enterFullscreen, exitFullscreen, playerTarget } = this.props;
    if (isFullScreen) {
      exitFullscreen();
    } else {
      enterFullscreen();
    }

    if (document.pictureInPictureElement) {
      document.exitPictureInPicture();
    } else if (playerTarget[0].webkitPresentationMode === 'picture-in-picture') {
      playerTarget[0].webkitSetPresentationMode('inline');
    }

    document.activeElement.blur();
  };

  render() {
    return (
      <FullScreenButtonStyled
        data-role="fullscreen"
        icon={this.state.iconName}
        iconSize={26}
        isMobile={this.props.isMobile}
        onClick={this.toggleFullscreen}
      />
    );
  }
}

FullscreenButton.propTypes = {
  enterFullscreen: PropTypes.func,
  exitFullscreen: PropTypes.func,
  isFullScreen: PropTypes.bool,
  isMobile: PropTypes.bool,
};

FullscreenButton.defaultProps = {
  enterFullscreen: Function.prototype,
  exitFullscreen: Function.prototype,
  isFullScreen: false,
  isMobile: false,
};

export default FullscreenButton;
